import { mergeStyleSets } from '@uifabric/merge-styles';
/**
 * Creates a getClassNames function which calls getStyles given the props, and injects them
 * into mergeStyleSets.
 */
export function classNamesFunction() {
    // TODO: memoize.
    return function (getStyles, styleProps) {
        return mergeStyleSets(getStyles && (typeof getStyles === 'function' ? getStyles(styleProps) : getStyles));
    };
}
//# sourceMappingURL=classNamesFunction.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uifabric/utilities/lib/classNamesFunction.js
// module id = 223
// module chunks = 0